export default class {
    constructor(Design) {
        this.Design = Design;
        this.bind();
    }

    bind() {
        $(document).on('click', 'a[href*="createMix?"]', async(e) => {
            e.preventDefault();
            const params = {
                instance:       this.Design.values.instance,
                name:           this.Design.values.name,
                description:    this.Design.values.description,
                design:         this.Design.values.design,
            };
            const ingredients       = [];
            const ingredientsArray  = new URL(e.target.href).search.substring(1).split(',');
            ingredientsArray.forEach(ingredient => {
                if (ingredient.includes('I')) {
                    const split = ingredient.split('I');
                    ingredients.push({
                        amount: split[0],
                        id: split[1]
                    });
                } else {
                    ingredients.push({
                        amount: 1,
                        id: ingredient
                    });
                }
            });
            const mix = await App.Interface.Mix.create(params, ingredients);
            window.location.href = App.Interface.I18n.appendLanguage(`/muesli/${mix.id}`);
        });
    }

    async show() {
        const params = {
            instance:    this.Design.values.instance,
            name:        this.Design.values.name,
            description: this.Design.values.description,
            design:      this.Design.values.design,
        }
        const searchParams = new URLSearchParams(params).toString();
        await App.Components.Popup.showXMLHttpRequestContent(`/mix-proposals?${searchParams}`);
        App.Components.Popup.Footer.Buttons.container.innerHTML = App.Template.parse('popup-footer-proposals');
        App.Components.Popup.Footer.update();
    }
}